import { render, staticRenderFns } from "./AdminPartnerCalculationsSettlementPage.vue?vue&type=template&id=d754a6b8&scoped=true"
import script from "./AdminPartnerCalculationsSettlementPage.vue?vue&type=script&lang=js"
export * from "./AdminPartnerCalculationsSettlementPage.vue?vue&type=script&lang=js"
import style0 from "./AdminPartnerCalculationsSettlementPage.vue?vue&type=style&index=0&id=d754a6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d754a6b8",
  null
  
)

export default component.exports